export default __webpack_public_path__ + "static/Fly5-0e87d500330dbad32d32d305af2dee1b.mp3";